import React from 'react';
import {MainNav} from '../main-nav/main-nav.component';
import {observer} from "mobx-react";
import {UserMenu} from '../user-menu/user-menu.component';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {HeaderComponent} from '../header/header.component';
import {DrawerComponent} from '../drawer/drawer.component';
import {OverlayComponent} from '../overlay/overlay.component';
import {SpinnerComponent} from '../spinner/spinner.component';
import {AppFooterComponent} from '../app-footer/app-footer.component';
import {MainScreenComponent} from '../../basic-components/main-screen/main-screen.component';
import {RouterOutletComponent} from '../router-outlet/router-outlet.component';
import {StickyNavigationMenuComponent} from '../sticky-navigation-menu/sticky-navigation-menu.component';
import {CyClass} from '../../../common/cy-classes';
import {FloatingBubblesComponent} from '../floating-bubbles/floating-bubbles.component';
import {MainWrapperBox} from "./boxes/main-wrapper.box";
import { OrbitSuspense } from '../base-components/orbit-suspense/orbit-suspense';
import { QA_ENVIRONMENT_POP_UP_BLOCKER_COOKIE } from '../../services/qa-environment-pop-up-blocker/qa-environment-pop-up-blocker.service.constants';
import {OnboardingTour} from '../onboarding-tour/onboarding-tour.component';

const QAEnvironmentPopUpBlocker = React.lazy(
    () => import("../qa-environment-pop-up-blocker/qa-environment-pop-up-blocker.component").then(({QAEnvironmentPopUpBlocker}) => ({default: QAEnvironmentPopUpBlocker}))
  );

export const ContainerComponent = observer(class ContainerComponent extends OrbitComponent<{}> {

    componentDidMount() {
        try {
            this._showQAEnvironmentPopUpBlocker();
        } catch (error) {
            console.error(error);
        }
    }

    private _showQAEnvironmentPopUpBlocker() {
        if (this.services.configuration.servicesConfigs.QAEnvironmentPopUp.enabled) {
            const qaEnvironmentPopUpBlockerCookie = this.services.cookies.getCookie(QA_ENVIRONMENT_POP_UP_BLOCKER_COOKIE);
            const queryParams = new URLSearchParams(this.services.window.location.search);

            if (!qaEnvironmentPopUpBlockerCookie && queryParams.get("shouldIgnoreQApopup" ) !== 'true') {
                this.services.dialog.showModal((dialogHandler) =>
                <OrbitSuspense>
                    <QAEnvironmentPopUpBlocker
                        dialogHandler={dialogHandler}
                    />
                </OrbitSuspense>,
                {
                    title: 'QA Environment',
                    shouldBeClosedOnlyByUser: true,
                    hideCloseButton: true,
                    isHighPriority: true
                })
            }
        }
    }

    private _renderRightDrawer() {
        // The key="right-drawer" is very important here because this will prevent react from completely destroy this drawer DOM element when the app is rerendered
        // We need his behavior for apps that supports minimization like the proactive chat.
        // When the user resize the window and apps goes from PC to Mobile view then the entire app is rerender and if we don't put the key attribute the drawer div is removed and another one is created so we loose the chat minimization state.
        return <DrawerComponent key="right-drawer" className={CyClass('cy-right-drawer')} drawer={this.services.drawer.right}/>
    }

    private _renderFullOrbitMobileLayout() {
        return (
            <>
                <SpinnerComponent/>
                <OverlayComponent/>
                <MainNav/>

                <MainWrapperBox className={'cy-main-wrapper'}>
                    <HeaderComponent/>

                    <MainScreenComponent>
                        <RouterOutletComponent/>
                        <AppFooterComponent/>
                    </MainScreenComponent>

                    <UserMenu/>
                    <StickyNavigationMenuComponent/>
                </MainWrapperBox>
                <FloatingBubblesComponent/>

                {this._renderRightDrawer()}
                <OnboardingTour />
            </>
        );
    }

    private _renderFullOrbitPcLayout() {
        return  (<>
            <SpinnerComponent/>
            <OverlayComponent/>
            <MainNav/>

                <MainWrapperBox className={'cy-main-wrapper'}>
                    <UserMenu/>
                    <HeaderComponent/>
                    <MainScreenComponent>
                        <FloatingBubblesComponent/>
                        <RouterOutletComponent/>
                        <AppFooterComponent/>
                    </MainScreenComponent>
                </MainWrapperBox>
            {this._renderRightDrawer()}
            <StickyNavigationMenuComponent/>
            <OnboardingTour />
        </>);
    }


    private _renderFullOrbit() {

        if (this.services.device.isMobile) {
            return this._renderFullOrbitMobileLayout();
        } else {
            return this._renderFullOrbitPcLayout();
        }
    }

    private _renderMiniOrbit() {
        return (
            <>
                <OverlayComponent/>
                <MainWrapperBox className={'cy-main-wrapper'}>
                    <RouterOutletComponent/>
                </MainWrapperBox>
            </>
        );
    }

    render() {
        if(this.services.miniOrbit.isEnabled) {
            return this._renderMiniOrbit();
        } else {
            return this._renderFullOrbit();
        }
    }
});
